import { Routes } from '@angular/router';

export const calendarModalRoutes: Routes = [
  {
    path: 'calendar/multi-event-selector',
    outlet: 'selector',
    loadChildren: () => import('./multi-day-event-selector/multi-day-event-selector.module').then((m) => m.MultiDayEventSelectorModule)
  }
];
